const state = {
	orgId: '',
	orgName: '',
	location: '',
	buyer: {'name': localStorage.getItem('SL_BI_name'),
		    'phone': localStorage.getItem('SL_BI_phone'),
			'state': localStorage.getItem('SL_BI_state')
		   },

	// StoreUIConfig data
	websiteLink: '',
	gProfileLink: null,
	showProducts: false,
	showMessages: false,
	showWholesalers: false,
	showPrices: false,
	// Minimum sale amount to show up in dealer list
	dealerClassLevel: 25000,
	// Minimum order amount to send order to seller
	dealerOrderLevel: 10000,
}

const mutations = {
	'UPDATE_ORG_ID' (state, orgId) {
		state.orgId = orgId
	},
	'UPDATE_ORG_NAME' (state, orgName) {
		state.orgName = orgName
	},
	'UPDATE_LOCATION' (state, location) {
		state.location = location
	},
	'UPDATE_BUYER' (state, {name, phone, stateSel}) {
		state.buyer.name = name
		localStorage.setItem('SL_BI_name', name);
		state.buyer.phone = phone
		localStorage.setItem('SL_BI_phone', phone);
		state.buyer.state = stateSel
		localStorage.setItem('SL_BI_state', stateSel);
	},
	'CLEAR_BUYER' (state) {
		state.buyer = {}
	},
	'UPDATE_STORE_UI' (state, {websiteLink, gProfileLink, showProducts, showMessages, 
							   showWholesalers, showPrices, dealerClassLevel, dealerOrderLevel}) {
		state.websiteLink = websiteLink
		state.gProfileLink = gProfileLink
		state.showProducts = showProducts
		state.showMessages = showMessages
		state.showWholesalers = showWholesalers
		state.showPrices = showPrices
		state.dealerClassLevel = dealerClassLevel
		state.dealerOrderLevel = dealerOrderLevel
	},
}

const actions = {
	setOrgId: ({commit}, {orgId}) => {
		commit('UPDATE_ORG_ID', orgId);
	},
	setOrgName: ({commit}, {orgName}) => {
		commit('UPDATE_ORG_NAME', orgName);
	},
	setBuyer: ({commit}, obj) => {
		commit('UPDATE_BUYER', obj);
	},
}

const getters = {
	orgId: (state) => {
		return state.orgId;
	},
	orgName: (state) => {
		return state.orgName;
	},
	buyer: (state) => {
		return state.buyer;
	},
	websiteLink: (state) => {
		return state.websiteLink;
	},
	gProfileLink: (state) => {
		return state.gProfileLink;
	},
	showProducts: (state) => {
		return state.showProducts;
	},
	showMessages: (state) => {
		return state.showMessages;
	},
	showWholesalers: (state) => {
		return state.showWholesalers;
	},
	showPrices: (state) => {
		return state.showPrices;
	},
	dealerClassLevel: (state) => {
		return state.dealerClassLevel;
	},
	dealerOrderLevel: (state) => {
		return state.dealerOrderLevel;
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}